export type PackageSearchFilters = {
  destination: string;
  /** Valeur enum API (ex. OMRA) ou '' pour toutes */
  category: string;
  /** '' ou '1'–'12' (mois civil) */
  month: string;
  /** '' | '1-3' | '4-7' | '8-14' | '15+' */
  duration: string;
  /** '' = tous les types, sinon filtre Package.type */
  packageType: '' | 'B2B' | 'B2C';
  /** id compagnie en string ou '' */
  airlineId: string;
};

export const EMPTY_PACKAGE_SEARCH_FILTERS: PackageSearchFilters = {
  destination: '',
  category: '',
  month: '',
  duration: '',
  packageType: '',
  airlineId: '',
};

/** Lecture / écriture des filtres dans l’URL (liste des séjours, route `/offres`) */
export function packageSearchFiltersFromParams(sp: URLSearchParams): PackageSearchFilters {
  const t = sp.get('t');
  const packageType = t === 'B2B' || t === 'B2C' ? t : '';
  return {
    destination: sp.get('d') ?? '',
    category: sp.get('c') ?? '',
    month: sp.get('m') ?? '',
    duration: sp.get('dur') ?? '',
    packageType,
    airlineId: sp.get('a') ?? '',
  };
}

export function paramsFromPackageSearchFilters(f: PackageSearchFilters): URLSearchParams {
  const q = new URLSearchParams();
  if (f.destination.trim()) q.set('d', f.destination.trim());
  if (f.category) q.set('c', f.category);
  if (f.month) q.set('m', f.month);
  if (f.duration) q.set('dur', f.duration);
  if (f.packageType) q.set('t', f.packageType);
  if (f.airlineId) q.set('a', f.airlineId);
  return q;
}
